import React from "react";
import Modal from "react-modal";
import { AiFillCloseCircle } from "react-icons/ai";

const ModalView = ({
  isModaOpen,
  setIsModalOpen,
  title,
  children,
  onClose,
}) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      // height: "100%",
      // minHeight: "300px",
      maxHeight: "200vh",
      maxWidth: "100vw",
      // minWidth: "500px",
      // width: "100%",
      //overflowY: "auto",
      padding: "10px",
    },
    overlay: { zIndex: 3000 },
  };

  const closeModal = () => {
    setIsModalOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal isOpen={isModaOpen} onRequestClose={closeModal} style={customStyles}>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #0001A4",
        padding: "1px",
      }}>
        <h4 style={{ 
          margin: "0", 
          fontSize: "1.3rem", 
          fontWeight: "600", 
          color: "#0001A4" 
        }}>
          {title}
        </h4>

        <AiFillCloseCircle
          size="2rem"
          color="#CE3B46"
          onClick={closeModal}
          role="button"
        />
      </div>
      <div >{children}</div>
    </Modal>
  );
};

export default ModalView;
